// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthMenu_link__1KJfd","activeLink":"AuthMenu_activeLink__2fWkW"};